module.exports = __webpack_public_path__ + "img/Lifting Order.8aaac726.svg";